import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { Map, List } from 'immutable';
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import { getOutcome } from "../context/selectors.js";
var restrict = function restrict(state, scope) {
  return state.getIn([scope, 'alignments']) || Map();
};
var alignedOutcomes = function alignedOutcomes(state, scope) {
  return restrict(state, scope).get('alignedOutcomes') || List();
};
var openAlignmentId = function openAlignmentId(state, scope) {
  return restrict(state, scope).get('openAlignmentId');
};

/**
 * LaunchContexts will be a list of at most 2 elements. It is only populated when we are aligning
 * outcomes to items in banks. The first element will always represent the root account context.
 * The second will be the context that the current user is in (root account, sub-account, or course).
 */
export var getLaunchContexts = createSelector(function (state, scope) {
  return restrict(state, scope).get('launchContexts');
}, function (launchContexts) {
  return (launchContexts === null || launchContexts === void 0 ? void 0 : launchContexts.toJS()) || null;
});

/**
 * This returns the last element in the list of launch contexts. This will be equivalent to the
 * context that the current user is in (root account, sub-account, or course).
 */
export function getLaunchContextUuid(state, scope) {
  var _launchContexts$slice;
  var launchContexts = getLaunchContexts(state, scope);
  return (launchContexts === null || launchContexts === void 0 ? void 0 : (_launchContexts$slice = launchContexts.slice(-1)[0]) === null || _launchContexts$slice === void 0 ? void 0 : _launchContexts$slice.uuid) || null;
}

/**
 * This returns the first element in the list of launch contexts. This will be equivalent to the
 * root account context.
 */
export function getRootAccountContextUuid(state, scope) {
  var _launchContexts$slice2;
  var launchContexts = getLaunchContexts(state, scope);
  return (launchContexts === null || launchContexts === void 0 ? void 0 : (_launchContexts$slice2 = launchContexts.slice(0)[0]) === null || _launchContexts$slice2 === void 0 ? void 0 : _launchContexts$slice2.uuid) || null;
}
export function isLaunchingFromRootAccount(state, scope) {
  var rootAccountContextUuid = getRootAccountContextUuid(state, scope);
  var launchContextUuid = getLaunchContextUuid(state, scope);
  return rootAccountContextUuid && rootAccountContextUuid === launchContextUuid;
}
export var getAlignedOutcomes = createCachedSelector(alignedOutcomes, function (alignedOutcomes) {
  return alignedOutcomes.toJS();
})(function (_state, scope) {
  return scope;
});
export var getAlignedOutcomeIds = createSelector(getAlignedOutcomes, function (outcomes) {
  return outcomes.map(function (o) {
    return o.id;
  });
});
export function getAlignedOutcomeCount(state, scope) {
  if (state && restrict(state, scope).get('alignedOutcomes')) {
    return restrict(state, scope).get('alignedOutcomes').filter(function (outcome) {
      return outcome.toJS().decorator !== 'HIDE';
    }).size;
  }
  return 0;
}
export var getAlignedOutcome = createSelector(function (state, scope, id) {
  return getAlignedOutcomes(state, scope).find(function (o) {
    return o.id === id;
  });
}, function (outcome) {
  return outcome;
});
function getOutcomeFromAnyContext(state, scope, id) {
  var launchContexts = getLaunchContexts(state, scope);
  if (launchContexts) {
    var _iterator = _createForOfIteratorHelper(launchContexts),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var launchContext = _step.value;
        var uuid = launchContext.uuid;
        var o = state.getIn(['context', 'outcomes', uuid, id.toString()]);
        if (o) {
          return o.toJS();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return null;
}
export function getAnyOutcome(state, scope, id) {
  return getAlignedOutcome(state, scope, id) || getOutcome(state, scope, id) || getOutcomeFromAnyContext(state, scope, id);
}
export function getOutcomeAlignmentSetId(state, scope) {
  return restrict(state, scope).get('alignmentSetId');
}
export var makeIsOpen = createCachedSelector(openAlignmentId, function (openAlignments) {
  return function (id) {
    return openAlignments === id;
  };
})(function (_state, scope) {
  return scope;
});